var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-toolbar-title',{staticClass:"page-top-legend-tile"},[_vm._v(_vm._s(this.projectname))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }